import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pencil",
  "use": "pencil-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" class=\"icon icon-tabler icon-tabler-pencil\" viewBox=\"0 0 24 24\" id=\"pencil\"><path stroke=\"none\" d=\"M0 0h24v24H0z\" /><path d=\"M4 20h4L18.5 9.5a1.5 1.5 0 0 0-4-4L4 16zM13.5 6.5l4 4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol